module.exports = __webpack_public_path__ + "img/01.a322c5d6.svg";